import React from "react";

interface IProps {
  isShowLogout: boolean;
  setIsShowLogout: () => void;
}

const ModalConfirmLogout: React.FC<IProps> = ({
  isShowLogout,
  setIsShowLogout,
}) => {
  const Cookies = require("js-cookie");

  return (
    <div className={`model-group ${isShowLogout ? "active" : ""} `}>
      <div
        id="logout-model "
        className={`model-item model-logout ${
          isShowLogout ? "model-logout_active" : ""
        } `}
        style={{
          color: "rgb(255, 255, 255)",
          fontFamily: "Prompt",
          boxSizing: "border-box",
          padding: "40px 0px",
          width: "calc(-35px + 100vw)",
          position: "relative",
          maxWidth: "500px",
          backgroundImage: 'url("/assets/frame_popup-desktop.png")',
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          display: "block",
          zIndex: 1000,
          font: "16px / 24px Prompt",
        }}
      >
        <div
          className="btn-closeModel"
          onClick={setIsShowLogout}
          style={{
            color: "rgb(255, 255, 255)",
            fontFamily: "Prompt",
            boxSizing: "border-box",
            backgroundPosition: "center center",
            position: "absolute",
            top: "0px",
            right: "0px",
            width: "35px",
            height: "35px",
            marginLeft: "auto",
            backgroundImage: 'url("/assets/close_bt.png")',
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            cursor: "pointer",
          }}
        />
        <div
          className="wrapper text-center"
          style={{
            color: "rgb(255, 255, 255)",
            fontFamily: "Prompt",
            boxSizing: "border-box",
            padding: "20px",
            border: "unset",
            backgroundColor: "unset",
            textAlign: "center",
          }}
        >
          <div
            className="title"
            style={{
              color: "rgb(255, 255, 255)",
              fontFamily: "Prompt",
              boxSizing: "border-box",
            }}
          >
            <h1
              style={{
                fontFamily: "Prompt",
                boxSizing: "border-box",
                lineHeight: 1.2,
                clear: "both",
                fontWeight: 600,
                marginTop: "24px",
                marginBottom: "15px",
                paddingBottom: "10px",
                color: "rgb(255, 255, 255)",
                fontSize: "32px",
              }}
            >
              Đăng xuất
            </h1>
            <h3
              style={{
                boxSizing: "border-box",
                clear: "both",
                fontFamily: "Kanit-Light",
                color: "rgb(255, 255, 255)",
                lineHeight: 1.2,
                fontWeight: 500,
                marginTop: "0px",
                marginBottom: "0px",
                fontSize: "26px",
              }}
            >
              Bạn có chắc muốn đăng xuất không?
            </h3>
          </div>
          <form
            style={{
              color: "rgb(255, 255, 255)",
              fontFamily: "Prompt",
              boxSizing: "border-box",
            }}
          >
            <div
              className="group-btn mt-4"
              style={{
                color: "rgb(255, 255, 255)",
                fontFamily: "Prompt",
                boxSizing: "border-box",
                textAlign: "center",
                left: "0px",
                width: "100%",
                position: "relative",
                marginTop: "1.5rem",
              }}
            >
              <button
                className="btn-cancel"
                onClick={setIsShowLogout}
                type="button"
                style={{
                  color: "rgb(255, 255, 255)",
                  boxSizing: "border-box",
                  borderRadius: "0px",
                  margin: "0px",
                  fontFamily: "inherit",
                  fontSize: "inherit",
                  lineHeight: "inherit",
                  overflow: "visible",
                  textTransform: "none",
                  appearance: "button",
                  border: "unset",
                  outline: "unset",
                  backgroundPosition: "center center",
                  transition: "0.3s",
                  backgroundColor: "unset",
                  backgroundImage: 'url("/assets/no_bt.png")',
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  width: "200px",
                  height: "45px",
                  cursor: "pointer",
                }}
              />
              <button
                onClick={() => {
                  Cookies.remove("access_token");
                  setIsShowLogout();
                  window.location.reload();
                  localStorage.removeItem("user_info");
                }}
                className="btn-confirm"
                type="button"
                style={{
                  color: "rgb(255, 255, 255)",
                  boxSizing: "border-box",
                  borderRadius: "0px",
                  margin: "0px",
                  fontFamily: "inherit",
                  fontSize: "inherit",
                  lineHeight: "inherit",
                  overflow: "visible",
                  textTransform: "none",
                  appearance: "button",
                  border: "unset",
                  outline: "unset",
                  backgroundPosition: "center center",
                  transition: "0.3s",
                  backgroundColor: "unset",
                  backgroundImage: 'url("/assets/yes_bt.png")',
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  width: "200px",
                  height: "45px",
                  cursor: "pointer",
                }}
              />
            </div>
          </form>
        </div>
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
@media (min-width: 769px) {
  .model-item.model-logout,
  .model-group .model-item.model-logout,
  .model-group .model-logout {
    background-image: url("/assets/frame_popup-desktop.png") !important;
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
    background-color: transparent !important;
  }
  
  .model-group .btn-cancel {
    background-image: url("/assets/no_bt.png") !important;
    background-size: contain !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
    width: 200px !important;
    height: 45px !important;
  }
  
  .model-group .btn-confirm {
    background-image: url("/assets/yes_bt.png") !important;
    background-size: contain !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
    width: 200px !important;
    height: 45px !important;
  }
  
  .model-group .btn-closeModel {
    background-image: url("/assets/close_bt.png") !important;
    background-size: contain !important;
    background-repeat: no-repeat !important;
  }
}
`,
        }}
      />
    </div>
  );
};

export default ModalConfirmLogout;
